export const getChildren = ({cms}) => cms.children;
export const getContent = ({cms}) => cms.content;
export const getSelectedParentPage = ({cms}) => cms.selectedParentPage;

export const selectCMSContentById = ({cms: {content}}, id) => content[id];
export const getEntireStore = store => store;
